var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.3333 0.384918H10.6667C3.85778 0.384918 0 4.39107 0 11.4618V30.8465C0 37.8988 3.84 41.9234 10.6667 41.9234H29.3333C36.1422 41.9234 40 37.8988 40 30.8465V11.4618C40 4.39107 36.1422 0.384918 29.3333 0.384918Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.457 15.6125C14.0198 15.6125 13.6654 15.9669 13.6654 16.4041V27.4875C13.6654 27.9247 14.0198 28.2791 14.457 28.2791H25.5404C25.9776 28.2791 26.332 27.9247 26.332 27.4875V16.4041C26.332 15.9669 25.9776 15.6125 25.5404 15.6125H14.457ZM12.082 16.4041C12.082 15.0925 13.1454 14.0291 14.457 14.0291H25.5404C26.852 14.0291 27.9154 15.0925 27.9154 16.4041V27.4875C27.9154 28.7992 26.852 29.8625 25.5404 29.8625H14.457C13.1454 29.8625 12.082 28.7992 12.082 27.4875V16.4041Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1667 12.4458C23.6039 12.4458 23.9583 12.8002 23.9583 13.2375V16.4041C23.9583 16.8414 23.6039 17.1958 23.1667 17.1958C22.7294 17.1958 22.375 16.8414 22.375 16.4041V13.2375C22.375 12.8002 22.7294 12.4458 23.1667 12.4458Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8346 12.4458C17.2719 12.4458 17.6263 12.8002 17.6263 13.2375V16.4041C17.6263 16.8414 17.2719 17.1958 16.8346 17.1958C16.3974 17.1958 16.043 16.8414 16.043 16.4041V13.2375C16.043 12.8002 16.3974 12.4458 16.8346 12.4458Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.082 19.5708C12.082 19.1336 12.4365 18.7791 12.8737 18.7791H27.1237C27.5609 18.7791 27.9154 19.1336 27.9154 19.5708C27.9154 20.008 27.5609 20.3625 27.1237 20.3625H12.8737C12.4365 20.3625 12.082 20.008 12.082 19.5708Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidTime);
export default __webpack_public_path__ + "static/media/ValidTime.0a26dc6bc85c800a7eab28b30fff3c95.svg";
export { ForwardRef as ReactComponent };